import {Dispatch} from "redux";
import {BrandsAPI, MixesAPI} from "../services/api/Api";
import {IBrandsTobacco, IMix, ITastesMixer} from "../constants/types";
import {AppStateType} from "../services/rootReducer";

const GET_INFO_BRAND_START = 'TastesBrand/GET_INFO_BRAND_START';
const GET_INFO_BRAND_SUCCESS = 'TastesBrand/GET_INFO_BRAND_SUCCESS';
const SET_ACTIVE_TASTES_ID = 'TastesBrand/SET_ACTIVE_TASTES_ID';
const REMOVE_ACTIVE_TASTES_ID = 'TastesBrand/REMOVE_ACTIVE_TASTES_ID';
const CLEAN_ACTIVE_TASTES_ID = 'TastesBrand/CLEAN_ACTIVE_TASTES_ID';
const GET_RESULT_MIXER_START = 'TastesBrand/GET_RESULT_MIXER_START';
const GET_RESULT_MIXER_SUCCESS = 'TastesBrand/GET_RESULT_MIXER_SUCCESS';
const SET_SELECTED_MIX_ID = 'TastesBrand/SET_SELECTED_MIX_ID';
const UPDATE_MIXER_MIX = 'TastesBrand/UPDATE_MIXER_MIX';
const SET_LOADING_TRUE = 'TastesBrand/SET_LOADING_TRUE';

interface ITastesBrandState {
    isLoading: boolean,
    activeInfoBrand: Array<IBrandsTobacco> | null,
    tastes: Array<ITastesMixer>,
    resultMixer: Array<IMix>,
    selectedMix: number | null
}

interface ITastesBrandAction {
    type: string,
    payload: any
}

const initialState: ITastesBrandState = {
    isLoading: true,
    activeInfoBrand: null,
    tastes: [],
    resultMixer: [],
    selectedMix: null
};

export const setLoadingTrue = () => ({
    type: SET_LOADING_TRUE,
});

const setInfoBrand = (res: Array<IBrandsTobacco>) => ({
    type: GET_INFO_BRAND_SUCCESS,
    payload: res
});

const setResultMixer = (res: Array<IMix>) => ({
    type: GET_RESULT_MIXER_SUCCESS,
    payload: res
});

export const cleanSelectedTastes = () => (dispatch: Dispatch) => {
    dispatch({
        type: CLEAN_ACTIVE_TASTES_ID
    });
};

export const getInfoBrand = (id: number) => (dispatch: Dispatch) => {
    dispatch({type: GET_INFO_BRAND_START});
    BrandsAPI.getFullInfoBrand(id)
        .then(res => dispatch(setInfoBrand(res)))
        .catch(e => console.log(e))
};

export const handleIdMix = (id: number, name: string, brandName: string, isActive: boolean) => (dispatch: Dispatch) => {
    if (isActive) {
        dispatch({
            type: SET_ACTIVE_TASTES_ID,
            payload: [id, name, brandName]
        })
    } else {
        dispatch({
            type: REMOVE_ACTIVE_TASTES_ID,
            payload: id
        })
    }
};

export const removeMix = (id: number) => (dispatch: Dispatch) => {
    dispatch({
        type: REMOVE_ACTIVE_TASTES_ID, payload: id
    })
};

const changeMixerMix = (countLikes: number, isLiked: boolean, indexMix: number) => ({
    type: UPDATE_MIXER_MIX,
    payload: [countLikes, isLiked, indexMix]
});

export const updateMixerMix = (id: number, isMixLiked: boolean) => {
    return async (dispatch: Dispatch, getState: () => AppStateType) => {
        const mixCompilation = getState().tastesBrand.resultMixer;
        const mixIndex = mixCompilation.findIndex((item: any) => item.id === id);
        if (isMixLiked) {
            const res = await MixesAPI.unlikeMix(id);
            dispatch(changeMixerMix(res.likeCount, false, mixIndex));
        } else {
            const res = await MixesAPI.likeMix(id);
            dispatch(changeMixerMix(res.likeCount, true, mixIndex));
        }
    }
};

export const getResultMixer = () => (dispatch: Dispatch, getState: () => AppStateType) => {
    dispatch({type: GET_RESULT_MIXER_START});
    const tastesID = getState()
        .tastesBrand.tastes
        .map((item: any) => item.id);
    MixesAPI.getMixer(tastesID)
        .then(res => dispatch(setResultMixer(res)))
        .catch(e => console.log(e))
};

export const setSelectedIndex = (id: number) => (dispatch: Dispatch) => {
    dispatch({
        type: SET_SELECTED_MIX_ID,
        payload: id
    });
};

const TastesBrandReducer = (state = initialState, action: ITastesBrandAction): ITastesBrandState => {

    switch (action.type) {

        case GET_INFO_BRAND_START:
            return {
                ...state,
                isLoading: true
            };

        case GET_INFO_BRAND_SUCCESS:
            return {
                ...state,
                activeInfoBrand: action.payload,
                isLoading: false
            };

        case SET_LOADING_TRUE:
            return  {
              ...state,
              isLoading: true
            };

        case SET_ACTIVE_TASTES_ID:
            return {
                ...state,
                tastes: [...state.tastes, {
                    id: action.payload[0],
                    name: action.payload[1],
                    brandName: action.payload[2]
                }]
            };

        case REMOVE_ACTIVE_TASTES_ID:
            return {
                ...state,
                tastes: state.tastes.filter((item: any) => item.id !== action.payload)
            };

        case GET_RESULT_MIXER_START:
            return {
                ...state,
                isLoading: true
            };

        case GET_RESULT_MIXER_SUCCESS:
            return {
                ...state,
                resultMixer: action.payload,
                isLoading: false
            };

        case SET_SELECTED_MIX_ID:
            return {
                ...state,
                selectedMix: action.payload
            };

        case CLEAN_ACTIVE_TASTES_ID:
            return {
                ...state,
                tastes: []
            };

        case UPDATE_MIXER_MIX: {
            const newState: any = [...state.resultMixer];
            const [likeCount, isLiked, indexMix] = action.payload;
            newState[indexMix].isLiked = isLiked;
            newState[indexMix].likeCount = likeCount;
            return {
                ...state,
                resultMixer: newState
            }
        }

        default:
            return state;
    }
};

export default TastesBrandReducer;
